import { faPlane } from "@jewlr/pro-regular-svg-icons/faPlane"
import { Box, Flex, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

const Container = styled.div`
  background-color: #eef6e8;
  border-radius: 10px;
  text-align: center;
  ${(props) =>
    props.inCart
      ? `
    border: 1px solid #b4d4b4;
    margin-left: auto;
    margin-right: auto;
    padding: 16px 10px;
    width: 100%;
    ${props.theme.mediaQueries.tablet`
      border: none;
      margin-top: 32px;
      width: 461px;
    `}
  `
      : `
    margin-bottom: 16px;
    padding-bottom: 8px;
    padding-top: 8px;
    ${props.theme.mediaQueries.tablet`
      padding: 10px;
    `}
  `}
`

const StyledIcon = styled(FontAwesomeIcon).attrs({
  fontSize: "16px",
})`
  transform: rotate(-45deg);
`

const Text = styled(Typography)`
  font-size: 14px;
  letter-spacing: -0.03em;

  span {
    font-weight: 700;
  }
`

export const ProgressText = styled(Typography)`
  color: #3e693e;
  font-size: 10px;
  letter-spacing: -0.03em;
`

export const ProgressBar = styled(Box)`
  background: #c1deb0;
  border-radius: 10px;
  height: 6px;
  width: 100%;
`

export const Progress = styled(Box)`
  background: ${(props) => props.theme.colors.greenDarker};
  border-radius: 10px;
  height: 100%;
  width: ${(props) => props.progress}%;
`

const TravelCasePromo = ({ amountNeeded, inCart }) => {
  const promoMinimum = sl.config.travel_case_promo?.minimum || 0

  return (
    <Container inCart={inCart}>
      <Flex
        alignItems="center"
        justifyContent="center"
        mb={inCart ? "2px" : { _: 1, tablet: "4px" }}
      >
        <StyledIcon color="greenDarker" icon={faPlane} mr="4px" />
        <Typography
          color="greenDarker"
          fontSize="16px"
          fontWeight="700"
          letterSpacing="-0.03em"
        >
          FREE TRAVEL CASE WITH PURCHASE
        </Typography>
      </Flex>
      <Text>
        Choose your {jewlr_t("terms.jewelry")} case when you spend{" "}
        {to_currency(promoMinimum)} or more.
      </Text>
      <Text>
        USE CODE: <span>{sl.config.travel_case_promo?.code}</span>
      </Text>
      {inCart && (
        <Box maxWidth="278px" mt={2} mx="auto" width="100%">
          <ProgressBar>
            <Progress
              progress={((promoMinimum - amountNeeded) / promoMinimum) * 100.0}
            />
          </ProgressBar>
          <Flex alignItems="center" justifyContent="space-between" mt="2px">
            <ProgressText>
              {amountNeeded > 0
                ? `You’re ${to_currency(
                    amountNeeded
                  )} away from getting a Free Travel Case`
                : "Your order qualifies for a Free Travel Case"}
            </ProgressText>
            <ProgressText bold>{to_currency(promoMinimum)}</ProgressText>
          </Flex>
        </Box>
      )}
    </Container>
  )
}

TravelCasePromo.propTypes = {
  amountNeeded: PropTypes.number,
  inCart: PropTypes.bool,
}

export default TravelCasePromo
